import React, { FC } from 'react'
import { PrintLayout } from 'components/Layout'
import { PrintPreparingDeliveryOrderTemplate } from 'components/Templates'

const PrintPreparingDeliveryOrder: FC = () => {
  const title = '未発送の注文'
  return (
    <PrintLayout title={title}>
      <PrintPreparingDeliveryOrderTemplate title={title} />
    </PrintLayout>
  )
}

export default PrintPreparingDeliveryOrder
